import { Component, OnInit } from '@angular/core';
import { ServiceService } from '../service.service';
import { DatePipe } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { SharedService } from 'src/app/pages/shared/shared.service';
import { OrderXpcnDialogComponent } from '../../shared/order-xpcn-dialog/order-xpcn-dialog.component';
import { MapDialogComponent } from '../../shared/map-dialog/map-dialog.component';
import { DownloadExcelService } from 'src/app/services/download-excel.service';

@Component({
  selector: 'app-in-transit',
  templateUrl: './in-transit.component.html',
  styleUrls: ['./in-transit.component.scss']
})
export class InTransitComponent implements OnInit {
  tripsFlows: any[] = [];
  VehicleNumber: any;
  VehicleLatitude: any;
  VehicleLongitude: any;
  length = 0;
  pageIndex = 1;
  pageSize = 5;

  dateType = '';
  showCustomDate = false;
  fromDate = '';
  toDate = '';
  selectedFilter = 'any';
  selectedStatus = '';
  keyword = '';
  excelData: any[];
  public totalSize = 0;
  click = 0; // ✅ Needed for XPCN dialog open

  constructor(
    private serviceService: ServiceService,
    private datePipe: DatePipe,
    private dialog: MatDialog,
    public _booking: SharedService,
    public _downloadExcelService: DownloadExcelService,
    public _tripService: ServiceService,
  ) {}

  ngOnInit(): void {
    this.getOrders();
  }

  getOrders(): void {
    const requestData: any = {
      OrderBy: null,
      DateType: this.dateType || 'Dates',
      StartIndex: (this.pageIndex - 1) * this.pageSize + 1,
      PageLength: this.pageSize,
      FilterBy: '',
      Keyword: '',
      KeywordDate: '',
      StartDate: this.fromDate ? this.datePipe.transform(this.fromDate, 'yyyy-MM-dd') : '',
      EndDate: this.toDate ? this.datePipe.transform(this.toDate, 'yyyy-MM-dd') : '',
      Delay1: '',
      Delay2: '',
      KeyWordDistance: '',
      IsDelayClicked: false
    };

    // Dynamic keyword-based filter
    switch (this.selectedFilter) {
      case 'booking_id': requestData.BookingId = this.keyword; break;
      case 'order_id': requestData.OrderId = this.keyword; break;
      case 'xpls': requestData.xplsNo = this.keyword; break;
      case 'xpcn': requestData.xpcnNo = this.keyword; break;
      case 'vehicle_number': requestData.VehicleNo = this.keyword; break;
    }

    this.serviceService.getTripsFlow(requestData).subscribe({
      next: (response: any) => {
        const flows = response?.Data?.TripsFlows;
        if (flows) {
          this.tripsFlows = flows;
          this.length = flows[0]?.TotalCount || 0;
          this.VehicleNumber = flows.map((flow: any) => flow.VehicleNumber);
          this.VehicleLatitude = flows.map((flow: any) => flow.VehicleLatitude);
          this.VehicleLongitude = flows.map((flow: any) => flow.VehicleLongitude);
        }
        console.log(this.VehicleNumber);
        console.log(this.VehicleLatitude);
        console.log(this.VehicleLongitude);
      },
      error: (err) => {
        console.error('Error fetching trips:', err);
      }
    });
  }

    public openMap(flow) {
      const mapData = {
        Latitude: flow.VehicleLatitude,
        Longitude: flow.VehicleLongitude,
        VehicleNo: flow.VehicleNumber
      };
    
      console.log('Opening Map with:', mapData);
    
      let dialogRef = this.dialog.open(MapDialogComponent, {
        data: {
          data: mapData,
          isService: false,
          vehiclenumber: flow.VehicleNumber
        },
        height: 'auto',
        width: '600px',
        autoFocus: false
      });
    }

  openXPCNPreview(item: any): void {
    if (this.click !== 0 || !item?.XPCNId) return;

    this.click++;

    const xpcnPayload = { XPCNId: item.XPCNId };

    this._booking.getFinalizeXPCN(xpcnPayload).subscribe({
      next: (response) => {
        const data = (response as any)?.Data;
        this.click = 0;

        if (!data) return;

        this.dialog.open(OrderXpcnDialogComponent, {
          data: {
            xpcn: data,
            invoices: data.Invoices,
            waybills: data.WayBills,
            showFreight: false
          },
          height: 'auto',
          width: '900px',
          autoFocus: false
        });
      },
      error: (err) => {
        this.click = 0;
        console.error('Failed to fetch XPCN details:', err);
      }
    });
  }

  onPageChange(event: any): void {
    this.pageIndex = event.pageIndex + 1;
    this.pageSize = event.pageSize;
    this.getOrders();
  }

  setDateFilter(dateFilter: string): void {
    this.dateType = dateFilter;
    this.showCustomDate = false;
    this.getOrders();
  }
  
  toggleCustomDate(): void {
    this.showCustomDate = !this.showCustomDate;
    if (!this.showCustomDate) {
      this.fromDate = '';
      this.toDate = '';
    }
  }

  onFilterChange(event: any): void {
    if (this.selectedFilter !== 'status') {
      this.selectedStatus = '';
    }
  }

  applyFilters(): void {
    this.getOrders();
  }

  formatTime(minutes: number): string {
    if (!minutes && minutes !== 0) return '-';
    const hrs = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return `${hrs}h ${mins}m`;
  }  

  clearFilters(): void {
    this.selectedFilter = 'any';
    this.selectedStatus = '';
    this.keyword = '';
    this.getOrders();
  }

 public exportAsExcel(): void {
  this.excelData = [];
  const requestData: any = {
    OrderBy: null,
    DateType: this.dateType || 'Dates',
    StartIndex: 1,
    PageLength: this.totalSize > 0 ? this.totalSize : 10000,
    FilterBy: '',
    Keyword: '',
    KeywordDate: '',
    StartDate: this.fromDate ? this.datePipe.transform(this.fromDate, 'yyyy-MM-dd') : '',
    EndDate: this.toDate ? this.datePipe.transform(this.toDate, 'yyyy-MM-dd') : '',
    Delay1: '',
    Delay2: '',
    KeyWordDistance: '',
    IsDelayClicked: false
  };

  switch (this.selectedFilter) {
    case 'booking_id': requestData.BookingId = this.keyword; break;
    case 'order_id': requestData.OrderId = this.keyword; break;
    case 'xpls': requestData.xplsNo = this.keyword; break;
    case 'xpcn': requestData.xpcnNo = this.keyword; break;
    case 'vehicle_number': requestData.VehicleNo = this.keyword; break;
  }

  this._tripService.getTripsFlow(requestData).subscribe({
    next: (res: any) => {
      const list = res?.Data?.TripsFlows || [];

      if (list.length > 0) {
        list.forEach((element: any) => {
          this.excelData.push({
            'Booking Id': element.BookingNumber || '-',
            'Customer Name': element.CustomerName || '-',
            'Order ID': element.OrderNumber || '-',
            'XPCN/XPLS': element.XPCNNo || element.XPLSNo || '-',
            'Service Type': element.ServiceType || '-',
            'Origin': element.Origin || '-',
            'Via 1': element.Via1 || '-',
            'Via 2': element.Via2 || '-',
            'Destination': element.Destination || '-',
            'Vehicle Number': element.VehicleNumber || '-',
            'Actual Time Of Placement': this.datePipe.transform(element.OriginArrivedDate, 'dd-MM-y') || '-',
            'Departure Date & Time': this.datePipe.transform(element.OriginDepartedDate, 'dd-MM-y') || '-',
            'Estimated Time Of Arrival': this.datePipe.transform(element.ETA, 'dd-MM-y') || '-',
            'Dynamic ETA': element.DynamicETA || '-',
            'Revised ETA': this.datePipe.transform(element.RevisedEta, 'dd-MM-y') || '-',
            'Transit Time': element.TransitTime ? this.formatTime(element.TransitTime) : '-',
            'Current Transit Hours': element.CurrentTransitTime || '-',
            'Remaining Hrs': element.Remaininghours || '-',
            'Current Location': element.CurrentLocation || '-',
          });
        });
      } else {
        this.excelData.push({
          'Booking Id': '-',
          'Customer Name': '-',
          'Order ID': '-',
          'XPCN/XPLS': '-',
          'Service Type': '-',
          'Origin': '-',
          'Via 1': '-',
          'Via 2': '-',
          'Destination': '-',
          'Vehicle Number': '-',
          'Actual Time Of Placement': '-',
          'Departure Date & Time': '-',
          'Estimated Time Of Arrival': '-',
          'Dynamic ETA': '-',
          'Revised ETA': '-',
          'Transit Time': '-',
          'Current Transit Hours': '-',
          'Remaining Hrs': '-',
          'Current Location': '-',
        });
      }
      this._downloadExcelService.exportAsExcelFile(this.excelData, 'Intransit');
    },
    error: (err) => {
      console.error('Failed to download Excel:', err);
    }
  });
}

}
